export default __webpack_public_path__ + "static/media/ins-migracja.1a895363.jpg";